import { apiAxios } from '@app/api-client';
import type {
  PublicationPendingSubmitDto,
  PublicationPublishedDocumentDto,
  PublicationRejectedSubmitDto,
} from '@app/contracts';

export const fetchPublicationPendingValidations = (): Promise<PublicationPendingSubmitDto[]> =>
  apiAxios<PublicationPendingSubmitDto[]>({
    url: '/api/v1/publication/pending-validations',
    method: 'GET',
  });

export const fetchPublicationRejectedSubmissions = (): Promise<PublicationRejectedSubmitDto[]> =>
  apiAxios<PublicationRejectedSubmitDto[]>({
    url: '/api/v1/publication/rejected-submissions',
    method: 'GET',
  });

export const fetchPublicationPublished = (): Promise<PublicationPublishedDocumentDto[]> =>
  apiAxios<PublicationPublishedDocumentDto[]>({
    url: '/api/v1/publication/published',
    method: 'GET',
  });
